export default __webpack_public_path__ + "static/media/instagram_icon.02967a62.svg";